<template>
  <div class="day-view">
    <div class="day-header">
      <h3 class="day-title">
        {{ formatFullDate(currentDate) }}
      </h3>
    </div>

    <div
      ref="timeGrid"
      class="time-grid"
    >
      <div
        v-for="hour in hours"
        :key="hour"
        class="time-row"
      >
        <div class="time-label">
          {{ formatHour(hour) }}
        </div>
        <div
          class="time-cell"
          @click="$emit('timeSlotClick', { fullDate: currentDate, dateKey: formatDateKey(currentDate) }, hour)"
        >
          <div class="cell-events">
            <div
              v-for="event in getEventsForDayHour(hour)"
              :key="event.id"
              class="event-block"
              :style="{ backgroundColor: getStatusColor(event.status) }"
              @click.stop="$emit('eventClick', event)"
            >
              <div class="event-title">
                {{ event.cliente_id }} - {{ formatCliente(event.cliente) || 'Agendamento' }}
              </div>
              <div
                v-if="event.observacoes"
                class="event-desc"
              >
                {{ event.observacoes }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStatusColor, formatCliente, formatHour, formatFullDate, formatDateKey, hours } from '../calendar-utils'

export default {
  name: 'CalendarDayView',
  props: {
    currentDate: { type: Date, required: true },
    getEventsForDayHour: { type: Function, required: true },
  },
  data() {
    return { hours }
  },
  mounted() {
    this.scrollToHour(8)
  },
  methods: {
    getStatusColor,
    formatCliente,
    formatHour,
    formatFullDate,
    formatDateKey,
    scrollToHour(hour) {
      this.$nextTick(() => {
        const grid = this.$refs.timeGrid
        if (grid && grid.children[hour]) {
          grid.scrollTop = grid.children[hour].offsetTop - grid.offsetTop
        }
      })
    },
  },
}
</script>

<style scoped>
.day-view {
  background: #fff;
  min-height: 500px;
}

.day-header {
  border-bottom: 1px solid #dadce0;
  background: #fff;
  padding: 16px;
}

.day-title {
  font-size: 18px;
  font-weight: 400;
  color: #3c4043;
  margin: 0;
}

.time-grid {
  max-height: 600px;
  overflow-y: auto;
  background: #fff;
}

.time-row {
  display: flex;
  border-bottom: 1px solid #dadce0;
}

.time-label {
  width: 80px;
  flex-shrink: 0;
  border-right: 1px solid #dadce0;
  padding: 12px;
  text-align: right;
  font-size: 11px;
  color: #70757a;
}

.time-cell {
  flex: 1;
  min-height: 60px;
  cursor: pointer;
  padding: 8px;
}

.time-cell:hover {
  background: #f8fafd;
}

.cell-events {
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 200px;
  overflow-y: auto;
  padding-right: 4px;
}

/* Thin modern scrollbar for hourly event lists */
.cell-events::-webkit-scrollbar {
  width: 4px;
}
.cell-events::-webkit-scrollbar-track {
  background: transparent;
}
.cell-events::-webkit-scrollbar-thumb {
  background: #dadce0;
  border-radius: 4px;
}
.cell-events::-webkit-scrollbar-thumb:hover {
  background: #70757a;
}

.event-block {
  cursor: pointer;
  padding: 8px 10px;
  border-radius: 6px;
  color: #fff;
  transition: filter 0.15s;
}

.event-block:hover {
  filter: brightness(0.95);
}

.event-title {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.event-desc {
  font-size: 11px;
  opacity: 0.8;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
